<template>
  <div v-html="theHtml" />
</template>
<script>
export default {
  props: ["content", "type"],
  computed: {
    theHtml() {
      if (this.content == null || this.content.trim() === "") {
        return null;
      }
      if (this.type === "richText") {
        return this.content;
      } else {
        return this.content.replace(/\n/g, "<br/>");
      }
    }
  }
};
</script>
